/** Q3 option → markup rate (per quiz spec). C ("not sure") falls back to 30%. */
const MARKUP_RATE = {
    A: 0.225,
    B: 0.35,
    C: 0.30,
    D: 0.45,
};
const WEEKS_PER_QUARTER = 13;
const QUARTERS_PER_YEAR = 4;
const STARTER_MONTHLY = 99;
const ADVANCED_MONTHLY = 249;
export function markupRateFor(markup) {
    return MARKUP_RATE[markup] ?? 0.30;
}
/** Hires/month derived from agency hires over the last 3 months. */
export function hiresPerMonth(workers) {
    return workers / 3;
}
/** Implicit plan selection: Starter for ≤5 hires/mo, else Advanced. */
export function selectPlan(workers) {
    return hiresPerMonth(workers) <= 5 ? 'starter' : 'advanced';
}
/**
 * Verdict is decided strictly by the *real* comparison — does switching to Stanor
 * actually save money against the user's own numbers? If it doesn't, we say so.
 *   savings <= 0       -> 'keep'        (already lean; Stanor costs more today)
 *   0 < savings < 12k  -> 'borderline'  (a real, modest case for switching)
 *   savings >= 12k     -> 'fire'        (clearly overpaying the agency)
 */
export function verdictFor(savings) {
    if (savings <= 0)
        return 'keep';
    if (savings >= 12000)
        return 'fire';
    return 'borderline';
}
export function computeQuiz(a) {
    const markupRate = markupRateFor(a.markup);
    const markupCostPerWorkerQtr = a.wage * markupRate * a.hrsPerWeek * WEEKS_PER_QUARTER;
    const totalMarkupQtr = markupCostPerWorkerQtr * a.workers;
    const totalMarkupYear = totalMarkupQtr * QUARTERS_PER_YEAR;
    const plan = selectPlan(a.workers);
    const stanorYearCost = (plan === 'starter' ? STARTER_MONTHLY : ADVANCED_MONTHLY) * 12;
    const savings = totalMarkupYear - stanorYearCost;
    const stanorWins = savings > 0;
    const roi = stanorWins ? Math.round(totalMarkupYear / stanorYearCost) : 0;
    return {
        markupRate,
        markupCostPerWorkerQtr: Math.round(markupCostPerWorkerQtr),
        totalMarkupQtr: Math.round(totalMarkupQtr),
        totalMarkupYear: Math.round(totalMarkupYear),
        plan,
        stanorYearCost,
        savings: Math.round(savings),
        stanorWins,
        roi,
        verdict: verdictFor(savings),
    };
}
export function formatUsd(n) {
    return n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
}
